export default __webpack_public_path__ + "static/media/simbolo-blanco.09f0a3fb.png";